import { CSSProperties, MouseEventHandler, ReactNode } from "react";
import css from "../assets/css/uplife-button.module.css";

type ButtonVariant = "main" | "link" | "warn" | "outline" | "secondary" | "purple";
type ButtonSize = "small" | "medium" | "large";
type ButtonIcon = "deactivate" | "delete" | "plus";

interface UplifeButtonProps {
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  variant?: ButtonVariant;
  size?: ButtonSize;
  style?: CSSProperties;
  width?: string | number;
  icon?: ButtonIcon;
  iconPosition?: "left" | "right";
  className?: string;
  type?: "button" | "submit" | "reset";
}

const UplifeButton = ({
  children,
  onClick,
  disabled,
  variant = "main",
  size = "medium",
  style,
  width = "140",
  icon,
  iconPosition = "left",
  className,
  type,
}: UplifeButtonProps) => {
  const classes = [
    css.uplifeButton,
    css[`variant_${variant.toLowerCase()}`],
    css[`size_${size.toLowerCase()}`],
    className,
  ].filter(Boolean);

  const iconClasses = [css.uplifeButtonIcon];
  switch (icon) {
    case "deactivate":
      iconClasses.push(css.icon_deactivate);
      break;
    case "delete":
      iconClasses.push(css.icon_delete);
      break;
    case "plus":
      iconClasses.push(css.icon_plus);
      break;
  }

  return (
    <button
      type={type}
      style={{ ...style, width: width === "auto" ? "auto" : `${width}px` }}
      onClick={onClick}
      disabled={disabled}
      className={classes.join(" ")}
    >
      {icon && iconPosition === "left" && (
        <div className={iconClasses.join(" ")} />
      )}
      <span>{children}</span>
      {icon && iconPosition === "right" && (
        <div className={iconClasses.join(" ")} />
      )}
    </button>
  );
};

export default UplifeButton;
